<template>
    <v-container class="pa-5" fluid>
        <PersonalPackagesPickupOrdersDialog
            :is-open="personalPickupPackagesDialog"
            :list-selected="personalPickupPackages"
            :action="action"
            @on-save="addPersonalPickupPackages"
            @on-close="closePersonalPickupPackagesDialog"
        />        
        <ConfirmDialog
            :is-open="updatePersonalPickupDialog"
            @on-confirm="updatePersonalPickup"
            @on-abort="closeUpdatePersonalPickupDialog"
        >
            <template #content>
                Czy na pewno chcesz edytować odbiór osobisty?
            </template>
            <template #confirmButton>
                Potwierdź
            </template>
        </ConfirmDialog>
        <ConfirmDialog
            :is-open="changePersonalPickupStatusDialog"
            :action-loading="changePersonalPickupStatusLoading"
            @on-confirm="changePersonalPickupStatus"
            @on-abort="closeChangePersonalPickupStatusDialog"
        >
            <template #content>
                Czy na pewno chcesz potwierdzić odbiór osobisty?
            </template>
            <template #confirmButton>
                Potwierdź
            </template>
        </ConfirmDialog>
        <ConfirmDialog
            :is-open="editCountOfPackagesDialog"
            @on-confirm="editCountOfPackagesSave"
            @on-abort="() => editCountOfPackagesDialog = false"
        >
            <template #title>
                Liczba kartonów
            </template>
            <template #content>
                <v-text-field
                    ref="editFieldCountOfPackages"
                    v-model="editFieldCountOfPackages.value"
                    :error-messages="editFieldCountOfPackagesErrors"
                    label="Liczba kartonów"
                />
            </template>
            <template #confirmButton>
                Potwierdź
            </template>
        </ConfirmDialog>
        <page-title>
            {{ pageTitle }}
        </page-title>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    :disabled="actionLoading"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" xl="8" offset-xl="2">
                <v-container class="pa-0">
                    <v-row v-if="personalPickup && !isNewPersonalPickup">
                        <v-col cols="12" lg="6" class="d-flex">
                            <v-container class="pa-0">
                                <v-row>
                                    <v-col cols="12">
                                        <v-card>
                                            <v-toolbar flat dense color="white lighten-2">
                                                <v-toolbar-title>Dane odbioru osobistego</v-toolbar-title>
                                                <v-spacer />
                                                <v-tooltip :open-delay="tooltipDelay" top>
                                                    <template #activator="{on}">
                                                        <div v-on="on">
                                                            <v-btn
                                                                v-if="personalPickup.previewUrl"
                                                                icon
                                                                data-sentry-label="Podgląd WZ"
                                                                :disabled="blockPrintPreview"
                                                                @click="showPersonalPickupPreview(personalPickup.previewUrl)"
                                                            >
                                                                <v-icon color="blue">
                                                                    mdi-printer
                                                                </v-icon>
                                                            </v-btn>
                                                        </div>
                                                    </template>
                                                    <span v-if="blockPrintPreview">Przed wydrukiem zapisz zmiany</span>
                                                    <span v-else>Drukuj</span>
                                                </v-tooltip>
                                            </v-toolbar>
                                            <v-divider />
                                            <v-card-text>
                                                <v-container class="pa-0">
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <table class="table table--simple">
                                                                <tbody>
                                                                    <tr>
                                                                        <th>Numer:</th>
                                                                        <td>{{ personalPickup.number }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Utworzony przez:</th>
                                                                        <td v-if="personalPickup.createdBy.firstName && personalPickup.createdBy.lastName">
                                                                            {{ personalPickup.createdBy.firstName }} {{ personalPickup.createdBy.lastName }}
                                                                        </td>
                                                                        <td v-else>
                                                                            {{ personalPickup.username }}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Data utworzenia:</th>
                                                                        <td>{{ formatDate(personalPickup.createdAt) }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>
                    <v-row v-if="canUpdate" align="center">
                        <v-col cols="auto">
                            <h2 class="text-h6">
                                Dodaj paczkę do WZ
                            </h2>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn
                                color="secondary"
                                fab
                                small
                                class="elevation-1"
                                data-sentry-label="Dodaj paczkę do WZ"
                                @click="showPersonalPickupPackagesDialog()"
                            >
                                <v-icon>
                                    mdi-plus
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-card>
                                <v-toolbar v-if="!isNewPersonalPickup" flat dense color="white lighten-2">
                                    <v-toolbar-title>Paczka na WZ</v-toolbar-title>
                                </v-toolbar>
                                <v-divider v-if="!isNewPersonalPickup" />
                                <v-card-text v-if="personalPickupPackages.length > 0">
                                    <v-row>
                                        <v-col cols="auto">
                                            <h2 class="text-h6">
                                                Dodane paczki
                                            </h2>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-expansion-panels
                                                accordion
                                            >
                                                <v-expansion-panel v-for="personalPackage in personalPickupPackages" :key="personalPackage.id">
                                                    <v-expansion-panel-header>
                                                        <v-row align="center" dense>
                                                            <v-col cols="2">
                                                                <strong>{{ personalPackage.number }}</strong>
                                                            </v-col>
                                                            <v-col cols="4">
                                                                Klient: <strong>{{ personalPackage.customer }}</strong>
                                                            </v-col>
                                                            <v-col cols="2">
                                                                Liczba zamówień: <strong>{{ personalPackage.numberOfOrders }}</strong>
                                                            </v-col>
                                                            <v-col cols="3">
                                                                Liczba kartonów: <strong>{{ personalPackage.numberOfPackages }}</strong>
                                                                <v-btn
                                                                    v-if="canUpdate"
                                                                    icon
                                                                    @click.native="editCountOfPackages($event, personalPackage)"
                                                                >
                                                                    <v-icon color="blue">
                                                                        mdi-pencil
                                                                    </v-icon>
                                                                </v-btn>
                                                            </v-col>
                                                            <v-col cols="1">
                                                                <v-container fluid class="pa-0">
                                                                    <v-row justify="end" dense>
                                                                        <v-tooltip :open-delay="tooltipDelay" top>
                                                                            <template #activator="{on}">
                                                                                <v-btn
                                                                                    v-if="canUpdate"
                                                                                    icon
                                                                                    data-sentry-label="Usuń"
                                                                                    class="mr-4"
                                                                                    v-on="on"
                                                                                    @click="deletePersonalPickupPackage(personalPackage)"
                                                                                >
                                                                                    <v-icon color="pink">
                                                                                        mdi-delete
                                                                                    </v-icon>
                                                                                </v-btn>
                                                                            </template>
                                                                            <span>Usuń paczkę</span>
                                                                        </v-tooltip>
                                                                    </v-row>
                                                                </v-container>
                                                            </v-col>
                                                        </v-row>
                                                    </v-expansion-panel-header>
                                                    <v-divider />
                                                    <v-expansion-panel-content>
                                                        <v-row>
                                                            <v-col cols="12">
                                                                <v-container class="pa-0">
                                                                    <v-data-table
                                                                        :headers="orderHeader"
                                                                        :items="personalPackage.orders"
                                                                        :footer-props="footerProps"
                                                                    />
                                                                </v-container>
                                                            </v-col>
                                                        </v-row>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </v-col>
                                    </v-row>
                                </v-card-text>

                                <v-card-text v-else>
                                    <v-alert
                                        type="info"
                                        text
                                        border="left"
                                        class="ma-0"
                                    >
                                        Brak paczek na WZ.
                                    </v-alert>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                v-if="isNewPersonalPickup || personalPickup.statusId === 10"
                                color="success"
                                medium
                                class="mr-3"
                                data-sentry-label="Zapisz"
                                :loading="actionLoading"
                                :disabled="personalPickupPackages.length === 0 && action === 'create'"
                                @click="wantSavePersonalPickup"
                            >
                                Zapisz
                            </v-btn>
                            <v-btn
                                v-if="personalPickup.statusId === 10 && action === 'update'"
                                color="primary"
                                medium
                                class="mr-3"
                                data-sentry-label="Potwierdź"
                                :loading="changePersonalPickupStatusLoading"
                                :disabled="personalPickupPackages.length === 0"
                                @click="showChangePersonalPickupStatusDialog"
                            >
                                Potwierdź WZ
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { isEmpty } from 'lodash'
import store from '@/./store'
import { errorHandler } from '@/utils/errorHandler'
import { required, numeric } from 'vuelidate/lib/validators'
import tooltipDelay from '@/mixins/tooltip'
import dateFormatter from '@/mixins/dateFormatter'
import { apiConfig } from '@/config'
import PageTitle from '@/components/common/PageTitle'
import PersonalPackagesPickupOrdersDialog from './PersonalPackagesPickupOrdersDialog'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import pagination from '@/mixins/dataTablePagination'

export default {
    name: 'PersonalPackagePickup',
    components: {
        PageTitle,
        PersonalPackagesPickupOrdersDialog,
        ConfirmDialog
    },
    mixins: [
        tooltipDelay,
        dateFormatter,
        pagination,
    ],
    beforeRouteEnter(to, from, next) {
        if (typeof to.params.id !== 'undefined') {
            store.dispatch('shipments/personalPickups/getPersonalPickup', to.params.id)
                .then(response => {
                    next(vm => {
                        vm.action = 'update'
                        vm.personalPickup = Object.assign({}, response.data)
                        vm.personalPickupPackages = vm.personalPickup.personalPickupPackages.map(item => ({
                            ...item,
                            customer: item.orders?.at(0)?.customer ?? '-',
                            numberOfOrders: item.orders?.length ?? 0,
                            numberOfPackages: item.packageAmount,
                        }))
                        vm.pageTitle = `Odbiór osobisty - ${response.data.number}`
                    })
                })
                .catch(error => {
                    next(error)
                    errorHandler(error)
                })
        } else {
            next(vm => {
                vm.action = 'create'
                vm.pageTitle = 'Tworzenie odbioru osobistego'
            })
        }
    },
    data() {
        return {
            pageTitle: null,
            personalPickup: {},
            personalPickupPackagesDialog: false,
            editCountOfPackagesDialog: false,
            personalPickupPackages: [],
            actionLoading: false,
            action: null,
            updatePersonalPickupDialog: false,
            changePersonalPickupStatusLoading: false,
            changePersonalPickupStatusDialog: false,
            blockPrintPreview: false,
            editFieldCountOfPackages: {
                item: null,
                value: 0,
            },
            orderHeader: [
                {
                    text: 'Numer zamówienia klienta',
                    value: 'shopOrderNumber',
                    sortable: false,
                },
                {
                    text: 'Numer zamówienia',
                    value: 'productionNumber',
                    sortable: false,
                },
                {
                    text: 'Produkt',
                    value: 'firstProductName',
                    sortable: false,
                },
                {
                    text: 'Nakład',
                    value: 'quantity',
                    sortable: false,
                },
            ]
        }
    },
    validations() {
        return {
            personalPickupPackages: {
                $each: {
                    packageAmount: {
                        required,
                        isValid: (value) => {
                            return value > 0
                        }
                    }
                }
            },
            editFieldCountOfPackages: {
                value: {
                    required,
                    numeric,
                    maxValue: value => value > 0,
                }
            }
        }
    },
    computed: {
        isNewPersonalPickup() {
            return isEmpty(this.personalPickup)
        },
        canUpdate() {
            return this.isNewPersonalPickup || this.personalPickup.statusId === 10
        },
        editFieldCountOfPackagesErrors() {
            const errors = []

            if (!this.$v.editFieldCountOfPackages.value.required) errors.push('Pole jest wymagane.')
            if (!this.$v.editFieldCountOfPackages.value.numeric || !this.$v.editFieldCountOfPackages.value.maxValue ) errors.push('Proszę wpisać liczbę kartonów.')

            return errors
        },
    },
    methods: {
        showPersonalPickupPreview(pdfFile) {
            const file = this.taskPreviewURI(pdfFile)

            window.open(file, '_blank')
        },
        taskPreviewURI(image) {
            const mediaRoot = apiConfig.FACTORYBASE_API_URI

            return `${mediaRoot}${image}`
        },
        showPersonalPickupPackagesDialog() {
            this.personalPickupPackagesDialog = true
        },
        closePersonalPickupPackagesDialog() {
            this.personalPickupPackagesDialog = false
        },
        addPersonalPickupPackages(personalPickupPackages) {
            personalPickupPackages.forEach((personalPackage) => {
                const isAdded = this.personalPickupPackages.some(item => item.id === personalPackage.id)

                if (!isAdded) {
                    this.personalPickupPackages.push(personalPackage)
                }
                if (this.action === 'update') {
                    this.blockPrintPreview = this.personalPickupPackages.some(item => item.id === undefined)
                }
            })

        },
        deletePersonalPickupPackage(personalPackage) {
            const index = this.personalPickupPackages.findIndex(item => item.id === personalPackage.id)

            if (index > -1) this.personalPickupPackages.splice(index, 1)
        },
        wantSavePersonalPickup() {
            if (this.action === 'create') {
                this.savePersonalPickup()
            } else {
                this.showUpdatePersonalPickupDialog()
            }
        },
        savePersonalPickup() {
            const payload = this.personalPickupPackages.map(item => ({
                packageId: item.id,
                packageAmount: +item.numberOfPackages,
                orderAmount: +item.numberOfOrders,
            }))

            if (payload.length === 0 || payload.filter(item => !item.orderAmount).length) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: 'Dodanie odbioru osobistego nie powiodło się.',
                })

                return
            }
            this.$store.dispatch(
                'shipments/personalPickups/createPersonalPickupForPackage',
                { personalPickupPackages: payload }
            )
                .then( () => { this.close() })
                .catch(error => {
                    errorHandler(error)
                })
        },

        updatePersonalPickup() {
            const payload = {
                ...this.personalPickup,
                personalPickupPackages: this.personalPickupPackages.map(item => ({
                    id: item.id,
                    packageId: item.packageId,
                    packageAmount: +item.numberOfPackages,
                    orderAmount: +item.numberOfOrders,
                })),
            }

            this.closeUpdatePersonalPickupDialog()
            if (payload.personalPickupPackages.filter(item => !item.orderAmount).length) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: 'Dodanie odbioru osobistego nie powiodło się.',
                })

                return
            }

            this.$store.dispatch('shipments/personalPickups/updatePersonalPickup', payload)
                .then( () => { this.close() })
                .catch(error => {
                    errorHandler(error)
                })
            
        },
        showUpdatePersonalPickupDialog() {
            this.updatePersonalPickupDialog = true
        },
        closeUpdatePersonalPickupDialog() {
            this.updatePersonalPickupDialog = false
        },

        changePersonalPickupStatus() {
            this.updatePersonalPickupStatusLoading = true
            this.$store.dispatch('shipments/personalPickups/updatePersonalPickup', {
                ...this.personalPickup,
                statusId: 20,
            })
                .then(({ data }) => {
                    this.personalPickup = {
                        ...this.personalPickup,
                        statusId: data.statusId,
                    }
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.closeChangePersonalPickupStatusDialog()
                })
        },
        showChangePersonalPickupStatusDialog() {
            this.changePersonalPickupStatusDialog = true
        },
        closeChangePersonalPickupStatusDialog() {
            this.changePersonalPickupStatusLoading = false
            this.changePersonalPickupStatusDialog = false
        },

        editCountOfPackages(event, item) {
            event.stopPropagation()

            item.initialNumberOfPackages = +item.numberOfPackages
            this.editFieldCountOfPackages.item = item
            this.editFieldCountOfPackages.value = +item.numberOfPackages
            this.editCountOfPackagesDialog = true
            setTimeout(() => {
                this.$refs.editFieldCountOfPackages.focus(true)
            }, 500)
        },
        editCountOfPackagesSave() {
            this.editFieldCountOfPackages.item.numberOfPackages = this.editFieldCountOfPackages.value
            this.editCountOfPackagesDialog = false
        },
        close() {
            this.$router.push({ name: 'shipmentsPersonalPickups'})
                .catch(error => {
                    errorHandler(error)
                })
        },
    },
}
</script>